export const assetmgtHostAsset = [
  {
    "ahu_unique_id": "AHU-001",
    "ahu_description": "Main Lobby AHU",
    "area_zone_served": "Ground Floor Lobby",
    "department": "Facilities",
    "manufacturer": "Carrier",
    "model_number": "CRX-1000",
    "capacity_cfm": 1200,
    "number_of_filters": 3,
    "remarks": "Operational"
  },
  {
    "ahu_unique_id": "AHU-002",
    "ahu_description": "ICU Ventilation Unit",
    "area_zone_served": "ICU Ward",
    "department": "Medical",
    "manufacturer": "Daikin",
    "model_number": "DK-450",
    "capacity_cfm": 900,
    "number_of_filters": 4,
    "remarks": "Needs filter replacement"
  },
  {
    "ahu_unique_id": "AHU-003",
    "ahu_description": "Server Room AHU",
    "area_zone_served": "Data Center",
    "department": "IT",
    "manufacturer": "Trane",
    "model_number": "TR-300",
    "capacity_cfm": 800,
    "number_of_filters": 2,
    "remarks": "Temperature optimized"
  },
  {
    "ahu_unique_id": "AHU-004",
    "ahu_description": "Corridor AHU",
    "area_zone_served": "First Floor Corridors",
    "department": "Maintenance",
    "manufacturer": "Blue Star",
    "model_number": "BS-500",
    "capacity_cfm": 1000,
    "number_of_filters": 3,
    "remarks": "Scheduled for inspection"
  },
  {
    "ahu_unique_id": "AHU-005",
    "ahu_description": "Operation Theater AHU",
    "area_zone_served": "OT Block A",
    "department": "Surgery",
    "manufacturer": "Voltas",
    "model_number": "VL-OTX",
    "capacity_cfm": 1500,
    "number_of_filters": 5,
    "remarks": "High-performance filters installed"
  },
  {
    "ahu_unique_id": "AHU-006",
    "ahu_description": "AHU for Emergency Dept",
    "area_zone_served": "Emergency Room",
    "department": "Emergency",
    "manufacturer": "LG",
    "model_number": "LG-AHU-450",
    "capacity_cfm": 1100,
    "number_of_filters": 3,
    "remarks": "Operating within range"
  },
  {
    "ahu_unique_id": "AHU-007",
    "ahu_description": "Lab Ventilation Unit",
    "area_zone_served": "Pathology Lab",
    "department": "Diagnostics",
    "manufacturer": "Hitachi",
    "model_number": "HT-LAB",
    "capacity_cfm": 950,
    "number_of_filters": 2,
    "remarks": "Clean room compliant"
  },
  {
    "ahu_unique_id": "AHU-008",
    "ahu_description": "Pharmacy AHU",
    "area_zone_served": "Pharmacy Storage",
    "department": "Pharmacy",
    "manufacturer": "Samsung",
    "model_number": "SS-AHU-300",
    "capacity_cfm": 700,
    "number_of_filters": 2,
    "remarks": "Cooling stable"
  },
  {
    "ahu_unique_id": "AHU-009",
    "ahu_description": "Rehabilitation Block AHU",
    "area_zone_served": "Rehab Center",
    "department": "Rehabilitation",
    "manufacturer": "Mitsubishi",
    "model_number": "MS-AHU-900",
    "capacity_cfm": 1000,
    "number_of_filters": 3,
    "remarks": "No issues"
  },
  {
    "ahu_unique_id": "AHU-010",
    "ahu_description": "Pediatric Ward AHU",
    "area_zone_served": "Children's Ward",
    "department": "Pediatrics",
    "manufacturer": "Panasonic",
    "model_number": "PNC-700",
    "capacity_cfm": 850,
    "number_of_filters": 4,
    "remarks": "Check noise levels"
  },
  {
    "ahu_unique_id": "AHU-011",
    "ahu_description": "Radiology AHU",
    "area_zone_served": "MRI & CT Room",
    "department": "Radiology",
    "manufacturer": "Sharp",
    "model_number": "SH-AHU-800",
    "capacity_cfm": 950,
    "number_of_filters": 3,
    "remarks": "Energy-efficient model"
  },
  {
    "ahu_unique_id": "AHU-012",
    "ahu_description": "Admin Office AHU",
    "area_zone_served": "Admin Block",
    "department": "Administration",
    "manufacturer": "Whirlpool",
    "model_number": "WH-ADM-600",
    "capacity_cfm": 900,
    "number_of_filters": 2,
    "remarks": "Installed recently"
  }
]
